import { useState, useEffect, useRef } from 'react';
import './CategoriesDropdownMobile.scss';
import { useNavigate } from 'react-router-dom';
import { Category } from '../../../types/Category';
import useCategoryStore from '../../../store/categoryStore';

import { faChevronRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
interface CategoriesDropdownMobileProps {
    setIsOpen : (isOpen : boolean) => void;
}
const CategoriesDropdownMobile = ({setIsOpen}:CategoriesDropdownMobileProps) => {
  const [expandedCategories, setExpandedCategories] = useState<Record<string, boolean>>({});
  const { categories, getCategories } = useCategoryStore();
  const navigate = useNavigate();

  useEffect(() => {
    getCategories();
  }, [getCategories]);

  const toggleCategory = (categoryId: string) => {
    setExpandedCategories(prev => ({
      ...prev,
      [categoryId]: !prev[categoryId]
    }));
  };

  const handleNavigate = (catId : any) => {
    navigate(`/products?c=${catId}`);
    setIsOpen(false);
  }

  const renderCategories = (categories: Category[], level = 0) => {
    return categories.map((category) => {
      const hasChildren = category.children?.length > 0;
      const isExpanded = expandedCategories[category.id];

      return (
        <div key={category.id} className="category-container">
          <div 
            className={`category-item level-${level}`}
            onClick={() => hasChildren ? toggleCategory(category.id) : handleNavigate(category.id)}
          >
            <span className="category-name">{category.name}</span>
            {hasChildren && (
              <span className="arrow-icon">
                <FontAwesomeIcon 
                  icon={isExpanded ? faChevronDown : faChevronRight} 
                  className={isExpanded ? 'expanded' : ''}
                />
              </span>
            )}
          </div>

          {hasChildren && (
            <div className={`subcategories ${isExpanded ? 'expanded' : ''}`}>
              {renderCategories(category.children, level + 1)}
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <div className="mobile-categories-dropdown">
      {renderCategories(categories)}
    </div>
  );
};

export default CategoriesDropdownMobile;